import script from "./order-delivery.vue?vue&type=script&lang=ts&setup=true"
export * from "./order-delivery.vue?vue&type=script&lang=ts&setup=true"

import "./order-delivery.vue?vue&type=style&index=0&id=feb12afc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feb12afc"]])

export default __exports__